import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight, FiPlus } from 'react-icons/fi';
import AboutUsBanner from './AboutUsBanner';
import TeamSlider from './TeamSlider';
import { photos } from './Collage';
import Navbar2 from './Navbar2';
import { useMotionPreference } from '../voices/useScrollScene';
import '../voices/voices-company.css';

const values = [
  ['Trust', 'Clarity in the work, honesty in the conversation, and ownership that goes beyond a handoff.'],
  ['Innovation', 'Curiosity with a purpose. New possibilities, connected to the practical reality of your business.'],
  ['People', 'The people using the system. The people building it. A shared understanding of what better means.'],
];

function GalleryGrid({ items }) {
  return <div className="vc-gallery-grid">
    {items.map(photo => <figure key={photo.id}>
      <img src={photo.src} alt={`Life at Antrazal - company gallery moment ${photo.id}`} loading="lazy" decoding="async" width="1280" height="1024" />
    </figure>)}
  </div>;
}

export default function About() {
  const page = useRef(null);
  const [reduced] = useMotionPreference();

  useEffect(() => {
    if (reduced || typeof IntersectionObserver !== 'function') return;
    const elements = page.current.querySelectorAll('[data-company-reveal]');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.dataset.companyReveal = 'visible';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    elements.forEach(element => {
      // Content remains visible without observers or when motion is reduced.
      element.dataset.companyReveal = 'pending';
      observer.observe(element);
    });
    return () => {
      observer.disconnect();
      elements.forEach(element => { element.dataset.companyReveal = 'visible'; });
    };
  }, [reduced]);

  return <div className="vc-company" ref={page} data-voices-theme="dark">
    <Navbar2 />
    <AboutUsBanner reducedMotion={reduced} />
    <section className="vc-section vc-values" aria-label="Our values">
      <div className="vc-values-grid">
        {values.map(([title, description], index) => <article key={title}>
          <small>0{index + 1}</small><h2>{title}</h2><p>{description}</p>
        </article>)}
      </div>
    </section>
    <TeamSlider />
    <section className="vc-section vc-gallery" aria-labelledby="vc-gallery-title">
      <div className="vc-section-topline"><p className="vc-label">Life at Antrazal</p><span>Moments we have created.</span></div>
      <h2 className="vc-section-title" id="vc-gallery-title" data-company-reveal="visible">Moments we<br /><em>have created.</em></h2>
      <GalleryGrid items={photos.slice(0, 6)} />
      <details className="vc-gallery-more">
        <summary>Explore all 24 team moments <FiPlus aria-hidden="true" /></summary>
        <GalleryGrid items={photos.slice(6)} />
      </details>
      <Link className="vc-text-link vc-careers-link" to="/careers">Build your next chapter with us <FiArrowUpRight aria-hidden="true" /></Link>
    </section>
  </div>;
}
